module.exports = __webpack_public_path__ + "media/fonts/loader-37cdb302.svg";